import * as types from "_graphql-types/graphql";
import type { PerformanceFilterValue } from "../stores/knowledgeBaseStore";

/**
 * Public returns are stored as fractions and entered as percents; private
 * metrics are entered as stored (Net IRR in percent, TVPI/DPI as multiples).
 */
export function getPerformanceUnit({
  type,
  statType,
}: Pick<PerformanceFilterValue, "type" | "statType">) {
  if (type === "PERFORMANCE") return { scale: 100, suffix: "%" };
  return {
    scale: 1,
    suffix: statType === types.PerformancePrivateStatType.NetIrr ? "%" : "x",
  };
}
